import { countryDetailsFragment, newCountryFragment } from "@saleor/fragments/country";
import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { CountryDetails, CountryDetailsVariables } from "./types/CountryDetails";
import { ManagementCountryList, ManagementCountryListVariables } from "./types/ManagementCountryList";

const managementCountryList = gql`
    ${newCountryFragment}
    ${pageInfoFragment}
    query ManagementCountryList(
        $filter: CountryFilterInput
        $before: String
        $after: String
        $first: Int
        $last: Int
        $sort: CountrySortingInput
    ){
        countries(
            filter: $filter
            before: $before
            after: $after
            first: $first
            last: $last
            sortBy: $sort
        ){
          totalCount
            edges{
                node{
                    ...NewCountryFragment
                }
            }
            pageInfo {
                ...PageInfoFragment
            }
        }
    }
`;
export const useCountryListQuery = makeQuery<ManagementCountryList, ManagementCountryListVariables>(
    managementCountryList
  );

const countryDetails = gql`
  ${countryDetailsFragment}
  query CountryDetails($id: ID!) {
    country(id: $id) {
      ...CountryDetailsFragment
    }
  }
`;
 
export const useCountryDetailsQuery= makeQuery<
  CountryDetails,
  CountryDetailsVariables
>(countryDetails)